import type { Hit } from 'instantsearch.js';

import React from 'react';
import { usePageLink, useResourceLink } from './hooks';

const HitTitle = ({ hit }: { hit: Hit }) => {
  const isGradeBoundary = hit.doc_type === 'Grade Boundaries';

  const isPage = hit.type === 'module';

  const pageLink = usePageLink(hit, isPage);
  const resourceLink = useResourceLink(hit, isPage);

  const handleClick = () => {
    if (isPage) {
      pageLink();
    } else {
      resourceLink?.onClick();
    }
  };

  return (
    <button onClick={handleClick} style={{ padding: 0, margin: 0 }}>
      <h5 style={{ textAlign: 'left', marginBottom: 0 }}>
        {hit.name} {isGradeBoundary && `(${hit.doc_exam_course} ${hit.doc_exam_board})`}
      </h5>
    </button>
  );
};

export default HitTitle;
